const apiUrl = process.env.REACT_APP_API_URL;

export const PutDocument = async (id: string, nom: string, descripcio: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/documents/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ nom, descripcio })
        });
        return response;
    } catch (error) {
        console.log('Error:', error);
    }
};
